import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Section, SectionHeader } from "@/components/Section";
import { CTASection } from "@/components/CTASection";
import { SITE } from "@/lib/site";
import { seoTitle, seoDescription } from "@/lib/seo-meta";
import { listLocations } from "@/lib/services.functions";

const TITLE = seoTitle("Áreas de atendimento — Dedetizadora em Chapecó");
const DESC = seoDescription("Atendemos Chapecó, bairros e cidades da região oeste de Santa Catarina com controle de pragas profissional.");
const locsQ = { queryKey: ["locations-all"], queryFn: () => listLocations(), staleTime: 300_000 };

export const Route = createFileRoute("/locais/")({
  head: () => ({
    meta: [
      { title: TITLE }, { name: "description", content: DESC },
      { property: "og:title", content: TITLE }, { property: "og:description", content: DESC },
      { property: "og:url", content: "/locais" },
    ],
    links: [{ rel: "canonical", href: `${SITE.baseUrl}/locais` }],
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(locsQ),
  component: LocaisIndex,
  errorComponent: ({ error }) => <div className="container-svg py-20 text-center">Erro: {String(error)}</div>,
  notFoundComponent: () => { throw notFound(); },
});

function LocaisIndex() {
  const { data } = useSuspenseQuery(locsQ);
  const cities = data.filter((l) => !l.neighborhood);
  const bairros = data.filter((l) => l.neighborhood);
  return (
    <>
      <Section>
        <SectionHeader eyebrow="onde atendemos" title="Áreas de atendimento" description="Atendemos Chapecó e cidades da região oeste de Santa Catarina." />
        <h2 className="mt-10 text-xl font-bold">Cidades da região</h2>
        <ul className="mt-4 grid gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 text-sm">
          {cities.map((l) => (
            <li key={l.location_slug}>
              <Link to="/$location/$service" params={{ location: l.location_slug, service: "dedetizacao" }} className="block rounded border border-border bg-card px-3 py-2 hover:border-primary hover:text-primary transition-colors">{l.city} · SC</Link>
            </li>
          ))}
        </ul>
        <h2 className="mt-12 text-xl font-bold">Bairros de Chapecó</h2>
        <ul className="mt-4 grid gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 text-sm">
          {bairros.map((l) => (
            <li key={l.location_slug}>
              <Link to="/$location/$service" params={{ location: l.location_slug, service: "dedetizacao" }} className="block rounded border border-border bg-card px-3 py-2 hover:border-primary hover:text-primary transition-colors">{l.neighborhood}</Link>
            </li>
          ))}
        </ul>
      </Section>
      <CTASection title="Sua cidade ou bairro está aqui?" text="Fale conosco e agende uma vistoria gratuita." buttonLabel="Falar no WhatsApp" />
    </>
  );
}
